// require("babel-register")
// // ({
// //   presets: ["es2017", "react"]
// // });

// const router = require('./routes/index.js').default;
// const Sitemap = require('react-router-sitemap').default;

// (
//     new Sitemap(router)
//         .build('http://test-diagnosis.doctall.com/')
//         .save('./public/sitemap.xml')
// );

import React from "react";
import DynamicSitemap from "react-dynamic-sitemap";
// The import below should be updated to match your Router component
import Routes from "./routes/index.js";

export default function Sitemap(props) {
 
	return (
		<DynamicSitemap routes={Routes} prettify={true} {...props}
                    priority = "0.8"
                    changefreq = "monthly"
                    sitemapIndex = {true}
                     />
	);
}